import { render, staticRenderFns } from "./MinhasRecargas.vue?vue&type=template&id=053098fa"
import script from "./MinhasRecargas.vue?vue&type=script&lang=js"
export * from "./MinhasRecargas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports